import { BAD_RFP_MEMBER_CANT_INVITE_USER, BAD_RFP_MEMBER_DELETED, BAD_RFP_OFFER_MEMBER_CANT_INVITE_USER, BAD_RFP_OFFER_MEMBER_DELETED, BAD_RFP_OFFER_MEMBER_DUPLICATE_EMAIL, BAD_RFP_OFFER_MEMBER_HAS_OTHER_OFFER, BAD_RFP_OFFER_MEMBER_INVALID_ADMIN_SETTING, } from '../response';
/**
 * @deprecated TS化済 src/utils/constants/rfp/rfpErrorMessage.ts RFP_ADD_MEMBER_ERROR_MESSAGES
 */
export const RFP_ERROR_MESSAGES = {
    [BAD_RFP_OFFER_MEMBER_CANT_INVITE_USER]: '招待できないユーザーです',
    [BAD_RFP_OFFER_MEMBER_DELETED]: '招待できないユーザーです',
    [BAD_RFP_OFFER_MEMBER_DUPLICATE_EMAIL]: '既に招待済みのユーザーです',
    [BAD_RFP_OFFER_MEMBER_HAS_OTHER_OFFER]: 'このユーザーは既に提案済みのため、招待いただけません',
    [BAD_RFP_OFFER_MEMBER_INVALID_ADMIN_SETTING]: '責任者は1人までしか選択できません',
};
export const RFP_ERROR_CLIENT_MESSAGES = {
    [BAD_RFP_MEMBER_CANT_INVITE_USER]: '招待できないユーザーです',
    [BAD_RFP_MEMBER_DELETED]: '招待できないユーザーです',
};
/**
 * @deprecated TS化済 src/utils/constants/rfp/rfpType.ts
 */
export const RFP_TYPE_PUBLIC_OFFERING = {
    className: 'is-public',
    label: '公募案件',
    value: 1,
};
/**
 * @deprecated TS化済 src/utils/constants/rfp/rfpType.ts
 */
export const RFP_TYPE_DIRECT_OFFER = {
    className: 'is-direct',
    label: '直接紹介案件（Proffit Mart利用者限定）',
    value: 2,
};
/**
 * @deprecated TS化済 src/utils/constants/rfp/rfpType.ts
 */
export const RFP_TYPES = [RFP_TYPE_PUBLIC_OFFERING, RFP_TYPE_DIRECT_OFFER];
/**
 * @deprecated TS化済 src/utils/constants/rfp/isDisclose.ts
 */
export const RFP_IS_NOT_DISCLOSE = {
    label: '開示',
    value: 1,
};
/**
 * @deprecated TS化済 src/utils/constants/rfp/isDisclose.ts
 */
export const RFP_IS_DISCLOSE = {
    label: '非開示',
    value: 2,
};
/**
 * @deprecated 以降はutils/constants/rfp/paymentOption.tsを参照してください
 * @type {{timing: string, label: string, value: number, feeRate: number, status: string}}
 */
export const RFP_PAYMENT_OPTION_ONE_PERCENT = {
    feeRate: 0.01,
    label: '提案時に1％',
    status: '提案',
    timing: '提案された',
    value: 3,
};
/**
 * @deprecated 以降はutils/constants/rfp/paymentOption.tsを参照してください
 * @type {{timing: string, label: string, value: number, feeRate: number, status: string}}
 */
export const RFP_PAYMENT_OPTION_THREE_PERCENT = {
    feeRate: 0.03,
    label: '面談確定時に3％',
    status: '提案',
    timing: '面談確定された',
    value: 4,
};
/**
 * @deprecated 以降はutils/constants/rfp/paymentOption.tsを参照してください
 * @type {{timing: string, label: string, value: number, feeRate: number, status: string}}
 */
export const RFP_PAYMENT_OPTION_TEN_PERCENT = {
    feeRate: 0.1,
    label: '受注時に10%',
    status: '受注',
    timing: 'PJを受注された',
    value: 5,
};
/**
 * @deprecated 以降はutils/constants/rfp/paymentOption.tsを参照してください
 * @type {{timing: string, label: string, value: number, feeRate: number, status: string}}
 */
export const RFP_PAYMENT_OPTION_TWO_PERCENT = {
    feeRate: 0.02,
    label: '提案時に2％',
    status: '提案',
    timing: '提案された',
    value: 6,
};
/**
 * @deprecated 以降はutils/constants/rfp/paymentOption.tsを参照してください
 * @type {{timing: string, label: string, value: number, feeRate: number, status: string}[]}
 */
export const RFP_PAYMENT_OPTIONS = [
    RFP_PAYMENT_OPTION_ONE_PERCENT,
    RFP_PAYMENT_OPTION_TWO_PERCENT,
    RFP_PAYMENT_OPTION_THREE_PERCENT,
    RFP_PAYMENT_OPTION_TEN_PERCENT,
];
/**
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/memberType.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_OFFER_MEMBER_TYPE_COMPANY = {
    label: '社内メンバー',
    value: '1',
};
/**
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/memberType.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_OFFER_MEMBER_TYPE_OUTSIDE = {
    label: '共同提案メンバー（社外）',
    value: '2',
};
/**
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/memberType.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_OFFER_MEMBER_TYPES = [
    RFP_OFFER_MEMBER_TYPE_COMPANY,
    RFP_OFFER_MEMBER_TYPE_OUTSIDE,
];
export const RFP_OFFER_REPRESENTATIVE_ADMIN = {
    label: '案件責任者',
    value: '1',
};
export const RFP_OFFER_REPRESENTATIVE_MEMBER = {
    label: 'メンバー',
    value: '2',
};
export const RFP_OFFER_REPRESENTATIVES = [
    RFP_OFFER_REPRESENTATIVE_ADMIN,
    RFP_OFFER_REPRESENTATIVE_MEMBER,
];
/**
 * null:詳細閲覧を申請前
 * @deprecated 以降は utils/constants/viewRequest/status.ts を参照してください
 */
export const RFP_VIEW_REQUEST_STATUS_DEFAULT = {
    label: '詳細閲覧を申請する',
    short: '詳細閲覧申請',
    value: null,
};
/**
 * 1:提案依頼が未承認
 * @deprecated 以降は utils/constants/viewRequest/status.ts を参照してください
 */
export const RFP_VIEW_REQUEST_STATUS_UNAPPROVED = {
    label: '詳細閲覧を申請中',
    short: '詳細閲覧申請中',
    value: 1,
};
/**
 * 2:提案依頼を承認
 * @deprecated 以降は utils/constants/viewRequest/status.ts を参照してください
 */
export const RFP_VIEW_REQUEST_STATUS_APPROVAL = {
    label: '提案依頼を承認',
    short: '提案依頼承認',
    value: 2,
};
/**
 * 3:提案依頼を不承認
 * @deprecated 以降は utils/constants/viewRequest/status.ts を参照してください
 */
export const RFP_VIEW_REQUEST_STATUS_DISAPPROVED = {
    label: '申請は承認されませんでした',
    short: '提案依頼不承認',
    value: 3,
};
/**
 * 4:詳細閲覧決済を終了したのみ
 * @deprecated 以降は utils/constants/viewRequest/status.ts を参照してください
 */
export const RFP_VIEW_REQUEST_STATUS_END = {
    label: '詳細閲覧決済を終了',
    short: '詳細閲覧決済終了',
    value: 4,
};
/**
 * @deprecated 以降は utils/constants/viewRequest/status.ts を参照してください
 */
export const RFP_VIEW_REQUEST_STATUSES = [
    RFP_VIEW_REQUEST_STATUS_DEFAULT,
    RFP_VIEW_REQUEST_STATUS_UNAPPROVED,
    RFP_VIEW_REQUEST_STATUS_APPROVAL,
    RFP_VIEW_REQUEST_STATUS_DISAPPROVED,
    RFP_VIEW_REQUEST_STATUS_END,
];
/**
 * null:提案意向が未登録
 * @deprecated 以降はutils/constants/viewRequest/proposal.tsを利用してください
 */
export const RFP_VIEW_REQUEST_PROPOSAL_UNREGISTERED = {
    label: '提案意向が未登録',
    short: '提案意向未登録',
    value: null,
};
/**
 * 0:提案を辞退
 * @deprecated 以降はutils/constants/viewRequest/proposal.tsを利用してください
 */
export const RFP_VIEW_REQUEST_PROPOSAL_REFUSE = {
    label: '提案を辞退',
    short: '提案辞退',
    value: 0,
};
/**
 * 1:提案する
 * @deprecated 以降はutils/constants/viewRequest/proposal.tsを利用してください
 */
export const RFP_VIEW_REQUEST_PROPOSAL_TO_DO = {
    label: '提案済み',
    short: '提案済',
    value: 1,
};
/**
 * @deprecated 以降はutils/constants/viewRequest/proposal.tsを利用してください
 */
export const RFP_VIEW_REQUEST_PROPOSALS = [
    RFP_VIEW_REQUEST_PROPOSAL_UNREGISTERED,
    RFP_VIEW_REQUEST_PROPOSAL_REFUSE,
    RFP_VIEW_REQUEST_PROPOSAL_TO_DO,
];
/**
 * 役割 プロジェクト責任者
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/role.ts を参照してください
 */
export const RFP_ROLE_ADMINISTRATOR = {
    label: 'プロジェクト責任者',
    value: 1,
};
/**
 * 役割 プロジェクトマネージャー
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/role.ts を参照してください
 */
export const RFP_ROLE_MANAGER = {
    label: 'プロジェクトマネージャー',
    value: 2,
};
/**
 * 役割 スタッフ
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/role.ts を参照してください
 */
export const RFP_ROLE_STAFF = {
    label: 'スタッフ',
    value: 3,
};
/**
 * 役割 アドバイザー
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/role.ts を参照してください
 */
export const RFP_ROLE_ADVISER = {
    label: 'アドバイザー',
    value: 4,
};
/**
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/role.ts を参照してください
 * @type {({label: string, value: number}|{label: string, value: number}|{label: string, value: number}|{label: string, value: number})[]}
 */
export const RFP_ROLES = [
    RFP_ROLE_ADMINISTRATOR,
    RFP_ROLE_MANAGER,
    RFP_ROLE_STAFF,
    RFP_ROLE_ADVISER,
];
/**
 * メンバー体制 関わり方
 * 役割 リード
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/involvement.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_INVOLVEMENT_LEAD = {
    label: 'プロジェクトに専属し、検討を直接リード',
    value: 1,
};
/**
 * 役割 ファシリテート
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/involvement.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_INVOLVEMENT_FACILITATE = {
    label: '毎回の定例会に参加し、議論をファシリテート',
    value: 2,
};
/**
 * 役割 アドバイス
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/involvement.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_INVOLVEMENT_EXPERT = {
    label: '主要な定例会（中間報告・最終報告）にてアドバイス',
    value: 3,
};
/**
 * 役割 有識者
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/involvement.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_INVOLVEMENT_ADVICE = {
    label: '有識者として、必要に応じてチームにアドバイス',
    value: 4,
};
/**
 * 役割 未定
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/involvement.ts を参照してください
 * @type {{label: string, value: string}}
 */
export const RFP_INVOLVEMENT_OTHER = {
    label: '未定',
    value: 5,
};
/**
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/involvement.ts を参照してください
 * @type {{label: string, value: string}[]}
 */
export const RFP_INVOLVEMENTS = [
    RFP_INVOLVEMENT_LEAD,
    RFP_INVOLVEMENT_FACILITATE,
    RFP_INVOLVEMENT_EXPERT,
    RFP_INVOLVEMENT_ADVICE,
    RFP_INVOLVEMENT_OTHER,
];
/**
 * ステータス 提案メンバー
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/status.ts を参照してください
 * @type {{value: number}}
 */
export const RFP_OFFER_MEMBER_STATUS_OFFER_MEMBER = {
    value: 1,
};
/**
 * ステータス 案件共有のみ
 * @deprecated 以降は utils/constants/rfp/rfpOfferMember/status.ts を参照してください
 * @type {{value: number}}
 */
export const RFP_OFFER_MEMBER_STATUS_VIEW_ONLY = {
    value: 2,
};
/**
 * 質問対象者
 */
export const RFP_QUESTION_QUESTION_TARGET_CLIENT = {
    label: '企業担当者への質問',
    value: 1,
};
export const RFP_QUESTION_QUESTION_TARGETS = [
    RFP_QUESTION_QUESTION_TARGET_CLIENT,
];
/**
 * 回答ユーザ
 */
export const RFP_QUESTION_ANSWER_USER_TYPE_ADMIN = {
    label: '管理者',
    value: '1',
};
export const RFP_QUESTION_ANSWER_USER_TYPE_CLIENT = {
    label: '企業ユーザ',
    value: '2',
};
export const RFP_QUESTION_ANSWER_USER_TYPES = [
    RFP_QUESTION_ANSWER_USER_TYPE_ADMIN,
    RFP_QUESTION_ANSWER_USER_TYPE_CLIENT,
];
/**
 * オンライン質問 回答状態 未回答
 * @type {{label: string, value: number}}
 */
export const ONLINE_QUESTION_ANSWER_STATUS_NO_INPUT = {
    label: '未入力',
    value: 1,
};
/**
 * オンライン質問 回答状態 回答済み
 * @type {{label: string, value: number}}
 */
export const ONLINE_QUESTION_ANSWER_STATUS_INPUT = {
    label: '回答済み',
    value: 2,
};
/**
 * オンライン質問 回答状態 募集終了
 * @type {{value: number}}
 */
export const ONLINE_QUESTION_ANSWER_STATUS_END = {
    value: 3,
};
export const ONLINE_QUESTION_ANSWER_STATUS = [
    ONLINE_QUESTION_ANSWER_STATUS_NO_INPUT,
    ONLINE_QUESTION_ANSWER_STATUS_INPUT,
];
export const OFFER_STATUS_SELECTION = {
    label: '選定中',
    value: 1,
};
export const OFFER_STATUS_APPROVE = {
    label: '承認',
    value: 2,
};
export const OFFER_STATUS_NOT_APPROVE = {
    label: '見送り',
    value: 3,
};
export const OFFER_STATUS = [
    OFFER_STATUS_SELECTION,
    OFFER_STATUS_APPROVE,
    OFFER_STATUS_NOT_APPROVE,
];
